import DashboardPage from './pages/Dashboard.page';

DashboardPage.path = '/dashboard';

export default {
  pages: {
    DashboardPage,
  }
};
